import { render, staticRenderFns } from "./BookingAssistant1.vue?vue&type=template&id=e540e494&scoped=true&lang=pug&"
import script from "./BookingAssistant1.vue?vue&type=script&lang=ts&"
export * from "./BookingAssistant1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e540e494",
  null
  
)

export default component.exports